import { ValidatorTypes } from '@cashier/cashier-model';

import { SchemaCollector } from './model';

export const CommonFieldCollector: SchemaCollector = {
  collect: (formSchema, field) => {
    formSchema.commonFieldMap = formSchema.commonFieldMap || {};

    if (!formSchema.commonFieldMap[field.name]) {
      formSchema.commonFieldMap[field.name] = {
        ...field,
        validatorType: ValidatorTypes.COMMON,
      };
    }
  },
  shouldCollect: (_) => {
    return true;
  },
};
